import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _pt from 'prop-types';
import 'react';
import { filterDataAttributes } from '@commercetools-uikit/utils';
import { css } from '@emotion/react';
import { designTokens } from '@commercetools-uikit/design-system';
import { jsx } from '@emotion/react/jsx-runtime';

const getAlignItem = alignment => {
  switch (alignment) {
    case 'flexStart':
      return "flex-start";
    case 'flexEnd':
      return "flex-end";
    default:
      return alignment;
  }
};
const getMargin = scale => {
  switch (scale) {
    case 'xs':
      return designTokens.spacing10;
    case 's':
      return designTokens.spacing20;
    case 'm':
      return designTokens.spacing30;
    case 'l':
      return designTokens.spacing40;
    case 'xl':
      return designTokens.spacing50;
    case 'xxl':
      return designTokens.spacing60;
    case 'xxxl':
      return designTokens.spacing70;
    default:
      return 0;
  }
};

/**
 * We need to force the margin for the child elements as ome children
 * might have `margin: 0` defined, which results in a higher CSS specificity,
 * causing the margings of the spacing components to be ignored.
 * See https://github.com/commercetools/ui-kit/issues/542
 */
const getStyles = props => /*#__PURE__*/css("display:flex;flex-direction:column;align-items:", getAlignItem(props.alignItems), ";>*+*{margin:", getMargin(props.scale), " 0 0!important;}" + (process.env.NODE_ENV === "production" ? "" : ";label:getStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var getStyles$1 = getStyles;

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const Stack = props => jsx("div", _objectSpread(_objectSpread({
  css: getStyles$1(props)
}, filterDataAttributes(props)), {}, {
  children: props.children
}));
Stack.propTypes = process.env.NODE_ENV !== "production" ? {
  scale: _pt.oneOf(['xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl']).isRequired,
  alignItems: _pt.oneOf(['stretch', 'flex-start', 'flex-end', 'center', 'baseline', 'flexStart', 'flexEnd']).isRequired,
  children: _pt.node.isRequired
} : {};
const defaultProps = {
  scale: 's',
  alignItems: 'stretch'
};
Stack.displayName = 'Stack';
Stack.defaultProps = defaultProps;
var Stack$1 = Stack;

// NOTE: This string will be replaced on build time with the package version.
var version = "19.7.0";

export { Stack$1 as default, version };
